export enum RateTypeEnum {
  ALL_IN_RATE = "ALL_IN_RATE",
  NET_RATE = "NET_RATE",
  ALL_IN_TOTAL = "ALL_IN_TOTAL",
  NET_TOTAL = "NET_TOTAL",
}
